import { RenewalApplicationState } from '../App.state';
import { CustomerContactDetails, MatchMakerAnswers } from '../../shared/types';
type SaveForLaterDraft = {
  matchMakerAnswers?: MatchMakerAnswers;
  customerInformation?: CustomerContactDetails;
};
const draft: SaveForLaterDraft = {};
export const setMatchMakerAnswersDraft = (matchMakerAnswers: MatchMakerAnswers): void => {
  draft.matchMakerAnswers = matchMakerAnswers;
};
export const clearMatchMakerAnswersDraft = (): void => {
  delete draft.matchMakerAnswers;
};
export const setCustomerInformationDraft = (customerInformation: CustomerContactDetails): void => {
  draft.customerInformation = customerInformation;
};
export const clearCustomerInformationDraft = (): void => {
  delete draft.customerInformation;
};
export const getSaveForLaterDraft = (state: RenewalApplicationState): Required<SaveForLaterDraft> => ({
  matchMakerAnswers: draft.matchMakerAnswers ?? state.matchMakerAnswers,
  customerInformation: draft.customerInformation ?? state.customerInformation
});
